import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Auth from '../../../../auth/auth';
import { defaultTheme, PageShell, TopBar, UserChip, NxButton, NxIcon } from '../../../../components/nx';
import makeRequest from '../../../../api/makeRequest';
import url from '../../../../api/urls';
import { RequstMethods } from '../../../../api/requestMethode';
import { renderMarkdown } from '../../../../helpers/markdownHelper';

const t = defaultTheme;

const FRSCInstructions = () => {
    const navigate = useNavigate();
    const [title, setTitle] = useState<string>("");
    const [content, setContent] = useState<string>("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchInstructions() {
            try {
                const res = await makeRequest(url.settings.getByKey + "/instructions", RequstMethods.GET);
                if (res.status === 200 && res.data.data) {
                    setTitle(res.data.data.instructionTitle || "");
                    setContent(res.data.data.instructionContent || "");
                }
            } catch (e) {
                console.error("Failed to fetch instructions", e);
            } finally {
                setLoading(false);
            }
        }
        fetchInstructions();
    }, []);

    return (
        <PageShell t={t} style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <TopBar t={t} crumbs={['Instructions']} right={<UserChip t={t} onLogout={() => { Auth.signout(); navigate('/login'); }} />} />

            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 40 }}>
                <div style={{
                    width: '100%', maxWidth: 700,
                    background: t.surface, border: `1px solid ${t.border}`, borderRadius: 14,
                    overflow: 'hidden',
                }}>
                    <div style={{
                        padding: '20px 28px', borderBottom: `1px solid ${t.border}`,
                        background: t.paperAlt,
                    }}>
                        <h2 style={{ fontSize: 16, fontWeight: 600, color: t.ink, margin: 0 }}>
                            {loading ? "Loading..." : title || "Instructions"}
                        </h2>
                    </div>

                    <div style={{ padding: 28, fontSize: 14, lineHeight: 1.7, color: t.ink }}>
                        {loading ? (
                            <p style={{ color: t.inkMute }}>Loading instructions...</p>
                        ) : content ? (
                            <div dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }} />
                        ) : (
                            <p style={{ color: t.inkMute }}>No instructions available.</p>
                        )}

                        <div style={{ marginTop: 28 }}>
                            <NxButton t={t} kind="primary" icon={NxIcon.arrowRight('#fff')} onClick={() => navigate("/exam/dashboard")}>
                                Continue
                            </NxButton>
                        </div>
                    </div>
                </div>
            </div>
        </PageShell>
    );
};

export default FRSCInstructions;
